"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ReserveYourExperience() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="221543" id="enterprise-corporate-mobility" className="bg-white text-foreground relative flex min-h-[70vh] items-center justify-center overflow-hidden py-32 md:py-40">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-linear-to-b from-transparent to-surface/50" />
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1658108/img/executive_chauffeur_service.png)] bg-cover bg-center opacity-20 mix-blend-luminosity blur-[1px]" />
        <div className="absolute inset-0 bg-white/75 backdrop-blur-sm" />
      </div>

      {}
      <div ref={ref} className={`relative z-10 mx-auto flex w-full max-w-3xl flex-col items-center px-6 text-center transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
        <span className="mb-4 block text-sm font-medium tracking-widest text-primary uppercase">
          Corporate Solutions
        </span>
        
        <h2 className={`font-serif mb-6 text-4xl font-medium tracking-tight text-foreground md:text-5xl lg:text-7xl ${isVisible ? "animate-slide-up" : "opacity-0"}`} style={{
        animationDuration: '700ms'
      }}>
          Enterprise & Corporate Mobility
        </h2>
        
        <p className="mb-12 max-w-xl text-lg font-light text-secondary/80 md:text-xl">
          Elevate your business travel with priority support, monthly invoicing, and a dedicated fleet for your executive team.
        </p>
        
        <Button asChild size="lg" className="h-16 px-12 text-lg font-medium tracking-widest uppercase shadow-xl transition-all duration-400 hover:scale-110 hover:shadow-[0_0_30px_rgba(201,161,90,0.5)] bg-primary text-primary-foreground hover:bg-primary/90 rounded-md">
          <Link to="/HomePage">Inquire Now</Link>
        </Button>
      </div>
    </section>;
}